import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';
import type { ListMembersPage, SubscriberListView } from '@/types/api';

export interface CreateListPayload {
  name: string;
  description?: string;
}

export interface UpdateListPayload {
  name?: string;
  description?: string;
}

export const adminSubscriberListsService = {
  async list(): Promise<SubscriberListView[]> {
    return apiRequest<SubscriberListView[]>(apiRoutes.adminSubscriberLists.list, { method: 'GET' });
  },

  async create(payload: CreateListPayload): Promise<SubscriberListView> {
    return apiRequest<SubscriberListView>(apiRoutes.adminSubscriberLists.create, {
      method: 'POST',
      body: payload,
    });
  },

  async update(id: string, payload: UpdateListPayload): Promise<SubscriberListView> {
    return apiRequest<SubscriberListView>(apiRoutes.adminSubscriberLists.one(id), {
      method: 'PATCH',
      body: payload,
    });
  },

  async remove(id: string): Promise<void> {
    await apiRequest<void>(apiRoutes.adminSubscriberLists.one(id), { method: 'DELETE' });
  },

  async members(
    id: string,
    params: { page?: number; pageSize?: number } = {},
  ): Promise<ListMembersPage> {
    return apiRequest<ListMembersPage>(apiRoutes.adminSubscriberLists.members(id), {
      method: 'GET',
      query: { ...params },
    });
  },
};
